// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-UN2","label":"styles_label__1J4RC"};